// extracted by css-extract-rspack-plugin
export default {"cls1":"AffiliationPrompt-cls1_L7-","cls2":"AffiliationPrompt-cls2_qMa AffiliationPrompt-cls1_L7-"};